import type { ComponentType } from '@grafikr/components';
import Splide from '@splidejs/splide';

const Component: ComponentType = (node) => {
  const tabs = node.querySelectorAll('[data-tab]');
  const tabPanels = node.querySelectorAll('[data-tab-panel]');
  const activeClass = 'active';

  const initTabsSplide = () => {
    const tabsElement = node.querySelector<HTMLElement>('[data-splide-tabs]');
    const tabsSplide = new Splide(tabsElement, {
      autoWidth: true,
      pagination: false,
      arrows: false,
      drag: true,
    });

    tabsSplide.mount();
  };

  initTabsSplide();

  // The first tab should be active by default
  tabs[0].classList.add(activeClass);
  tabPanels[0].classList.add(activeClass);

  const handleClick = (e: Event) => {
    e.preventDefault();
    const clickedTab = e.target as HTMLElement;
    const tabId = clickedTab.dataset.tab;
    const tabPanel = node.querySelector(`[data-tab-panel="${tabId}"]`);

    tabs.forEach((tab) => tab.classList.remove(activeClass));
    tabPanels.forEach((panel) => panel.classList.remove(activeClass));

    clickedTab.classList.add(activeClass);
    tabPanel.classList.add(activeClass);
  };

  tabs.forEach((tab) => tab.addEventListener('click', handleClick));

  const readButton = node.querySelector('[data-read]');
  const productDescription = node.querySelector('[data-description]');

  if (readButton) {
    readButton.addEventListener('click', (e) => {
      e.preventDefault();
      readButton.classList.toggle('active');
      productDescription.classList.toggle('expanded');
    });
  }

  // if text content is less than 10 line clamps, hide the read more button and show the full text
  if (productDescription) {
    const textContentHeight = productDescription.clientHeight;
    const lineHeight = parseInt(window.getComputedStyle(productDescription).lineHeight, 10);
    const maxLines = 10;
    const maxContentHeight = lineHeight * maxLines;

    if (textContentHeight <= maxContentHeight) {
      productDescription.classList.add('expanded');
      readButton.classList.add('hidden');
    }
  }

  const videoElements = node.querySelectorAll('video');
  videoElements.forEach((videoElement) => {
    const playPauseButton = node.querySelector('[data-play-button]') as HTMLElement;

    const tempButton = playPauseButton.cloneNode(true) as HTMLElement;

    tempButton.removeAttribute('hidden');

    videoElement.parentNode.insertBefore(tempButton, videoElement);

    videoElement.volume = 0.5;

    const togglePlayPause = (button) => {
      button.classList.toggle('hidden');
      if (button.classList.contains('hidden')) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
    };

    tempButton.addEventListener('click', () => togglePlayPause(tempButton));

    videoElement.addEventListener('click', () => {
      if (videoElement.paused) {
        videoElement.play();
        tempButton.classList.add('hidden');
      } else {
        videoElement.pause();
        tempButton.classList.remove('hidden');
      }
    });
  });
};

export default Component;
